import GuidesAPI from 'media-base-ui/utils/guidesAPI';
import actionCreators from './actionCreators';

const fetchGuidesData = (season) => async dispatch => {
    dispatch(actionCreators.requestGuidesData());

    try {
        const data = await GuidesAPI.fetchGuidesByTeamData({season});
        dispatch(actionCreators.guidesDataResponse(true, season, data, null))
    } catch (error) {
        dispatch(actionCreators.guidesDataResponse(false, [], error))
    }
};

export default {
    fetchGuidesData
}
